import * as React from "react";

export const IconPlaylistAddCheck = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.5 13.3333L2.5 11.6667H9.16667L9.16667 13.3333L2.5 13.3333ZM2.5 10L2.5 8.33333L12.5 8.33333V10L2.5 10ZM2.5 6.66667L2.5 5L12.5 5V6.66667L2.5 6.66667ZM13.625 15.8333L10.6667 12.875L11.8333 11.7083L13.625 13.4583L17.1667 9.91667L18.3333 11.125L13.625 15.8333Z"
      fill="currentColor"
    />
  </svg>
);
